import { render } from "./AddNotifyUserModal.vue?vue&type=template&id=4b0e1b1d&scoped=true"
import script from "./AddNotifyUserModal.vue?vue&type=script&lang=js"
export * from "./AddNotifyUserModal.vue?vue&type=script&lang=js"

import "./AddNotifyUserModal.vue?vue&type=style&index=0&id=4b0e1b1d&lang=scss&scoped=true"

import exportComponent from "/home/ec2-user/src/FVC.frontend/Public/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b0e1b1d"]])

export default __exports__